import { Ellipse, Line, Rect, RegularPolygon } from 'react-konva'

import type { KonvaAnnotationKind } from './annotationSchema'

type BoundsShapeKind = Extract<
  KonvaAnnotationKind,
  'rect' | 'roundRect' | 'circle' | 'ellipse' | 'triangle' | 'diamond'
>

type KonvaAnnotationBoundsShapeProps = {
  fill?: string
  height: number
  isLegacySquare?: boolean
  isLegacyTriangle?: boolean
  kind: BoundsShapeKind
  offsetX?: number
  offsetY?: number
  roundRectCornerRadius?: number
  stroke: string
  strokeWidth: number
  width: number
}

const KonvaAnnotationBoundsShape = ({
  fill,
  height,
  isLegacySquare = false,
  isLegacyTriangle = false,
  kind,
  offsetX = 0,
  offsetY = 0,
  roundRectCornerRadius = 8,
  stroke,
  strokeWidth,
  width,
}: KonvaAnnotationBoundsShapeProps) => {
  if (kind === 'rect') {
    return (
      <Rect
        x={offsetX}
        y={offsetY}
        width={width}
        height={height}
        cornerRadius={isLegacySquare ? Math.max(width * 0.06, 3) : 0}
        stroke={stroke}
        strokeWidth={strokeWidth}
        fill={fill}
      />
    )
  }

  if (kind === 'roundRect') {
    return (
      <Rect
        x={offsetX}
        y={offsetY}
        width={width}
        height={height}
        cornerRadius={roundRectCornerRadius}
        stroke={stroke}
        strokeWidth={strokeWidth}
        fill={fill}
      />
    )
  }

  if (kind === 'circle' || kind === 'ellipse') {
    return (
      <Ellipse
        x={offsetX + width / 2}
        y={offsetY + height / 2}
        radiusX={width / 2}
        radiusY={height / 2}
        stroke={stroke}
        strokeWidth={strokeWidth}
        fill={fill}
      />
    )
  }

  if (kind === 'triangle') {
    return (
      <Line
        points={[
          offsetX + width / 2,
          offsetY,
          offsetX + width,
          offsetY + height,
          offsetX,
          offsetY + height,
        ]}
        closed
        stroke={stroke}
        strokeWidth={strokeWidth}
        fill={fill}
        lineJoin={isLegacyTriangle ? 'round' : 'miter'}
      />
    )
  }

  return (
    <RegularPolygon
      x={offsetX + width / 2}
      y={offsetY + height / 2}
      sides={4}
      radius={Math.min(width, height) / 2}
      stroke={stroke}
      strokeWidth={strokeWidth}
      fill={fill}
      rotation={45}
    />
  )
}

export default KonvaAnnotationBoundsShape
